
export default {
    name: 'GenericUpsell',
    props: ['featureName', 'tier'],
    computed: {
        buttonId() {
            if (!this.$auth.user.environment.isBusinessTier && !this.$auth.user.environment.isEnterpriseTier) {
                return 'open-pricing';
            } else {
                return 'upgrade-button-enterprise';
            }
        },
    },
    methods: {
        goToPricing() {
            this.$store.commit('ui/hideModal');
            this.$router.push('/pricing/');
        },
    },
};
